module.exports = __webpack_public_path__ + "ee08ea616536bbe3e5f67040ba2e2ccd.pdf";